import { render, staticRenderFns } from "./mapa.vue?vue&type=template&id=8f4cdcd2&"
import script from "./mapa.vue?vue&type=script&lang=js&"
export * from "./mapa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports